<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left;"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放打谱
        </el-col>
        <el-col :span="24" class="imgStyle" :style="heightCalc()" align="left" v-loading="loadingIframe">
            <iframe
                :id="`draggableIframe${serial}`"
                ref="draggableIframe"
                :src="`${draggableUrl}/draggableTopic/draggable.html?serial=${serial}`"
                frameborder="0"
                style="height:100%;width:100%;"
            ></iframe>
        </el-col>
    </div>
</template>
<script>
import utils, { json_P } from '../../lib/util'
import audioStyle from '../../components/audioStyle'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"clefTopic",
        props: {
            sonData: Object,
            allAnswer:Object,
            serial:Number,
            buttonNum:Number,
        },
        data() {
            return {
                draggableUrl:'',
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                loadingIframe:true,
                submitNum:0,
                plays:0,
                answerType:null,
                dragVal:'',
            }
        },
        components:{audioStyle},  
        watch: {
            'dragVal':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
        },
        mounted(){
            let that = this
            that.draggableUrl = process.env.INKNOTE_URL//inknote和draggable 域名一样
            // that.draggableUrl = 'http://192.168.3.41:10015'
            that.heart = that.sonData
            if(!that.heart.audioPlayTime) that.heart.audioPlayTime = -1
            that.plays = utils.mottoClone(that.heart.audioPlayTime)
            that.submitNum = utils.mottoClone(that.heart.submitNum)
            that.$nextTick(function(){
                if(that.allAnswer){
                    that.dragVal = that.allAnswer.obj.dragVal
                    that.plays = that.allAnswer.playss
                    that.submitNum = that.allAnswer.submitNum
                    that.answerType = that.allAnswer.obj.answerType
                }

                that.iframeLoading()

                // 接受
                window.addEventListener('message',function(e){
                    if(e.data&&e.data.type){
                        if(e.data.type == 'start'){
                            if(e.data.serial == that.serial){
                                let data_ = utils.deepClone2(that.heart.questionDto.detailInfo)
                                if(that.dragVal&&that.dragVal.length>0)
                                data_.positionVal = that.dragVal
                                that.sendIframeMsg({
                                    type:'sendData',
                                    serial:that.serial,
                                    boxColor:that.heart.questionDto.detailInfo.boxColor,
                                    data:data_
                                })
                            }
                        }else if(e.data.type == 'submitData'){
                            if(e.data.serial == that.serial){
                                that.iframeEmit(e.data.data)
                            }
                        }
                    }
                },false);  
            })
        },
        methods:{
            //接受拖拽的值
            iframeEmit(inknoteData){
                this.$set(this,'dragVal',inknoteData&&inknoteData.length<=0? '':inknoteData)
                
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    },this.serial)
                })
            },
            sendIframeMsg(param){
                //发送
                let iframeIn = document.getElementById(`draggableIframe${this.serial}`)
                iframeIn.contentWindow.postMessage(JSON.stringify(param),'*');
            },
            iframeLoading(){
                var that = this
                const iframe = document.getElementById(`draggableIframe${this.serial}`)
                // 处理兼容行问题
                if (iframe.attachEvent) {
                    iframe.attachEvent('onload', function () {
                        that.loadingIframe = false
                        console.log('iframe加载完成')
                    })
                } else {
                    iframe.onload = function () {
                        that.loadingIframe = false
                        console.log('iframe加载完成')
                    }
                }
            },
            startPlaying(){},
            endPlaying(){
                if(this.plays<=0) this.plays==-1? this.plays=-1:this.plays=0
                else this.plays--;
            },
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },

            heightCalc(){
                let h = '100%';
                let ch = this.heart.questionDto.detailInfo.audioUrl? '55px':'0px'
                return `height: calc(${h} - ${ch})`
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            top: 0;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 5px 10px 3px 10px;
            overflow: hidden;
        }
        @media only screen and (max-height: 713px) {
            .imgStyle{
                padding:2px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/draggableTopic.vue